// extracted by mini-css-extract-plugin
export default {"equireheading":"page_equireheading__pocLQ","inputmodified":"page_inputmodified__0MHuv"};